import { useEffect } from 'react';

import { useAnalytics } from 'shared/hooks/analytics/useAnalytics';

import type { AnalyticsEvent } from 'shared/constants/analytics';

export const useAnalyticsSessionDuration = (eventName?: AnalyticsEvent) => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.timeEvent(eventName);

    return () => {
      analytics.track(eventName);
    };
  }, [analytics, eventName]);
};
